import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import InfoLabel from 'UI/components/molecules/InfoLabel';
import { capitalizeFirstLetter, currencyFormatter } from 'UI/utils';
import { isTruthyValue } from 'utils';

const COPIES = strings.inventory.jobOrders.profile.jobDescriptionTab.sections.benefits;

export const Benefits = ({ benefits = [], compensationRange = null }) => {
  if ((!benefits || benefits?.length === 0) && !compensationRange) return null;

  const { ideal, period, maximum, minimum, currency } = compensationRange || {};

  return (
    <Section title={COPIES.title}>
      {compensationRange && (
        <>
          <Typography variant="subtitle1">{COPIES.compensationRange}</Typography>
          <Grid container spacing={4}>
            <Grid container item>
              {isTruthyValue(ideal) && (
                <Grid item xs={6} sm={3} md={2}>
                  <InfoLabel
                    cropped={false}
                    description={currencyFormatter(ideal)}
                    title="Ideal"
                    variant="body1"
                  />
                </Grid>
              )}

              {isTruthyValue(maximum) && (
                <Grid item xs={6} sm={3} md={2}>
                  <InfoLabel
                    cropped={false}
                    description={currencyFormatter(maximum)}
                    title="Maximum"
                    variant="body1"
                  />
                </Grid>
              )}
              {isTruthyValue(minimum) && (
                <Grid item xs={6} sm={3} md={2}>
                  <InfoLabel
                    cropped={false}
                    description={currencyFormatter(minimum)}
                    title="Minimum"
                    variant="body1"
                  />
                </Grid>
              )}

              {isTruthyValue(period) && (
                <Grid item xs={6} sm={3} md={2}>
                  <InfoLabel
                    cropped={false}
                    description={capitalizeFirstLetter(period)}
                    title="Period"
                    variant="body1"
                  />
                </Grid>
              )}
              {isTruthyValue(currency) && (
                <Grid item xs={6} sm={3} md={2}>
                  <InfoLabel
                    cropped={false}
                    description={currency}
                    title="Currency"
                    variant="body1"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <br />
        </>
      )}

      {benefits && benefits?.length !== 0 && (
        <>
          <Typography variant="subtitle1">{COPIES.benefits}</Typography>
          <ul>
            {benefits.map(
              benefit =>
                isTruthyValue(benefit) && (
                  <li key={benefit}>
                    <Typography variant="body1">{benefit}</Typography>
                  </li>
                )
            )}
          </ul>
        </>
      )}
    </Section>
  );
};
